import styled from 'styled-components';

export const MatrixDiscountContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f6f9fc;
  padding: 1.1rem;
  justify-content: space-around;
  margin-bottom: 1.2rem;

  @media (max-width: 1800px) {
    overflow-x: auto;
  }
`;

export const MatrixDiscountTable = styled.table`
  color: #8898aa;
  font-weight: 600;
  padding: 1.2rem;
  font-size: 0.65rem;
  text-transform: uppercase;
  white-space: break-spaces;
  line-height: 1.5rem;
  width: fit-content;

  th {
    text-align: center;
  }

  td {
    text-align: center;
  }

  .discount-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0 0.3rem;

    & > input {
      min-width: 5rem;
      margin-bottom: 0.25rem;
      align-items: center;
    }
    padding: 0 0.3rem 0 0.3rem;

    span {
      color: #8898aa;
      font-weight: 600;
      padding: 0 0.3rem;
    }
  }

  .discount_fields_description {
    display: flex;
    flex-direction: column;
    padding: 0 0.3rem 0 0.3rem;
    gap: 1.5rem;
  }

  .discount_fields_input_description {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 0;
    padding: 0;

    label {
      margin-bottom: 0px;
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
    }
  }

  .discount_columns_actions_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
  }

  .discount_rows_actions_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 0.25rem;
  }

  .discount_input_wrapper_all {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;
